import axios from "axios";
import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const NCHLCredentialsService = {
  // ============ NCHL Dynamic QR Credentials APIs ============

  // Get all Dynamic QR Credentials
  getDynamicQrCredsList: async () => {
    try {
      const response = await apiService.get(`/tenant/org-nchl-dynamic-qr-creds`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get Dynamic QR Credentials by ID
  getDynamicQrCredsDetail: async (id) => {
    try {
      const response = await apiService.get(
        `/tenant/org-nchl-dynamic-qr-creds/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get Dynamic QR Credentials by Organization ID
  getDynamicQrCredsByOrgId: async (organizationId) => {
    try {
      const response = await apiService.get(
        `/tenant/org-nchl-dynamic-qr-creds/organization/${organizationId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create Dynamic QR Credentials
  createDynamicQrCreds: async (data) => {
    try {
      const response = await apiService.post(
        `/tenant/org-nchl-dynamic-qr-creds`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update Dynamic QR Credentials
  updateDynamicQrCreds: async (id, data) => {
    try {
      const response = await apiService.put(
        `/tenant/org-nchl-dynamic-qr-creds/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete Dynamic QR Credentials
  deleteDynamicQrCreds: async (id) => {
    try {
      const response = await apiService.delete(
        `/tenant/org-nchl-dynamic-qr-creds/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Set Dynamic QR Credentials as Active
  setDynamicQrCredsActive: async (id) => {
    try {
      const response = await apiService.put(
        `/tenant/org-nchl-dynamic-qr-creds/set-active/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ============ NCHL Gateway Credentials APIs ============

  // Get all Gateway Credentials
  getGatewayCredsList: async () => {
    try {
      const response = await apiService.get(`/tenant/org-nchl-gateway-creds`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get Gateway Credentials by ID
  getGatewayCredsDetail: async (id) => {
    try {
      const response = await apiService.get(
        `/tenant/org-nchl-gateway-creds/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get Gateway Credentials by Organization ID
  getGatewayCredsByOrgId: async (organizationId) => {
    try {
      const response = await apiService.get(
        `/tenant/org-nchl-gateway-creds/organization/${organizationId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create Gateway Credentials
  createGatewayCreds: async (data) => {
    try {
      const response = await apiService.post(
        `/tenant/org-nchl-gateway-creds`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update Gateway Credentials
  updateGatewayCreds: async (id, data) => {
    try {
      const response = await apiService.put(
        `/tenant/org-nchl-gateway-creds/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete Gateway Credentials
  deleteGatewayCreds: async (id) => {
    try {
      const response = await apiService.delete(
        `/tenant/org-nchl-gateway-creds/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Set Gateway Credentials as Active
  setGatewayCredsActive: async (id) => {
    try {
      const response = await apiService.put(
        `/tenant/org-nchl-gateway-creds/set-active/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default NCHLCredentialsService;
